import React, { useEffect, useState } from "react";
import "./css/styles.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

const faq_img = require("./images/Faq-title-image.png");

const countriesFaqs = [
  {
    countryName: "GERMANY",
    countryShort: "Germany",
    overview:
      "An International Degree Course is a type of course that covers undergraduate",
    faqs: [
      {
        question: "Are the courses in Germany available in English?",
        answer:
          "Yes, there are many courses available across both graduation and post-graduation levels which are taught in English.",
      },
      {
        question: "What is an International Degree Course?",
        answer:
          "An International Degree Course is a type of course that covers undergraduate and postgraduate programs, along with some Ph.D. courses as well. These courses are taught in both English and German.",
      },
      {
        question:
          "Do foreign students need to have qualified IELTS or TOEFL to study in Germany?",
        answer:
          "If you are from a non English speaking country, then you will need IELTS or TOEFL certification.",
      },
      {
        question: "Is there an age limit applicable for postgraduate courses?",
        answer: "No, there is no such age limit.",
      },
      {
        question: "How much do higher studies cost in Germany?",
        answer:
          "In Germany, you are not required to pay any tuition fees at all in most areas of Germany. Students only need to pay for other charges like semester costs, administrative expenses. However, private universities do charge a tuition fees. A private university in Germany will cost you around 26,000 EUR/year for a Bachelor’s Degree and 40,000 EUR/ year for a Master’s Degree.",
      },
      {
        question:
          "Can I work part-time during my course to finance my studies?",
        answer:
          "Yes. International students get part-time work opportunities in this country. Full-time students who have come from non-EU countries can work up to 120 full days.",
      },
      {
        question: "What is meant by the term ‘Studienkolleg’?",
        answer:
          "‘Studienkolleg’ is a year-long preparatory course that makes students eligible for admission into German universities. It is for those students whose school-leaving certificate or diploma is not considered eligible.",
      },
      {
        question: "How can I study medicine in Germany?",
        answer:
          "Public universities offer courses in medicine for free. However, there is a lot of competition as there are limited seats, and you will require a strong knowledge of German and English. Medicine programs are not divided into Bachelor’s or Master’s but can take up to 6 years to complete.",
      },
      {
        question: "What are the entry requirements to study in Germany?",
        answer:
          "For undergraduate admissions, you will require either a school leaving certificate or a high school diploma, or university entrance exam results. For postgraduate studies, a degree certificate would be mandatory. Other requirements include language proficiency proofs and specific university requirements.",
      },
      {
        question: "Can I avail scholarships to study in Germany?",
        answer:
          "Yes, you can. Scholarships are offered by German universities, the German government, as well as several external funding bodies.",
      },
      {
        question: "Do I have to pay taxes when I am studying in Germany?",
        answer:
          "You have to pay taxes if your stay in Germany has exceeded more than 6 months or your monthly income is more than 450 euros.",
      },
      {
        question: "Is a student visa mandatory to study in Germany?",
        answer:
          "If you are from a non-EU country, then you will need a visa if you are planning to stay in Germany for more than 3 months.",
      },
      {
        question: "Whom should I approach for a student visa?",
        answer:
          "You can apply for your student visa at the German embassy in your country or at the consulate general’s office.",
      },
      {
        question: "What documents do I need to provide for the student visa?",
        answer: `<p>Though this may differ from country to country, generally, the documents required will be proofs of &ndash;</p>
        <p>Academic history<br />Admission from the German university<br />Health insurance coverage<br />Financial stability and income<br />Language skills</p>`,
      },
      {
        question: "Should I apply for a German bank account during my studies?",
        answer:
          "Though it is not mandatory, yet getting a German bank account will be helpful for your daily and important expenses.",
      },
    ],
  },
  {
    countryName: "U.S.A.",
    countryShort: "U.S.A.",
    overview: "",
    faqs: [
      {
        question:
          "There are so many schools in the U.S. How do I decide which schools to apply to?",
        answer:
          "Research your options and define your priorities. Contact the Education USA advising center nearest to you and browse college search engines online. Check to see if the schools you are considering are accredited.",
      },
      {
        question: "What’s the difference between a college and a university?",
        answer:
          "Colleges offer only undergraduate degrees while universities offer graduate degrees as well, but the terms are often used interchangeably.",
      },
      {
        question: "Are there age limitations to attend U.S. universities?",
        answer:
          "In general, you must have completed high school and you must be at least 17 years of age.",
      },
      {
        question:
          "What is the academic calendar for universities in the United States?",
        answer:
          "The academic year usually runs from August through May with breaks for holidays. Most universities use either the semester system (two terms), the quarter system (students attend three out of four total terms), or the trimester system (three terms).",
      },
      {
        question: `What is the difference between "Undergraduate" and "Graduate" degrees?`,
        answer:
          "Graduate degree typically refers to a degree beyond a bachelor’s, most commonly a master’s. A graduate student is a student who’s pursuing an advanced degree after having earned their undergraduate degree (such as a bachelor’s degree) by graduating from an undergraduate program.",
      },
      {
        question: "What are the different types of undergraduate degrees?",
        answer:
          "Associate: a two-year program that either leads to a specific vocation or transitions to a bachelor program. Bachelor: a four or five-year program where students earn credits in a wide variety of courses.",
      },
      {
        question: "What are the different types of graduate degrees?",
        answer:
          "Masters: two-year degree providing additional specialization. Doctorate: five to eight-year program certifying the student as a trained research scholar and/or professor.",
      },
      {
        question:
          "Is it possible to take a professional degree program without first earning a bachelor's degree?",
        answer:
          "Yes, but they are highly selective and require a heavy course load across a total of six years of study.",
      },
      {
        question:
          "Is it possible to obtain a bachelor's degree and a master's degree at the same time?",
        answer:
          "In a joint-degree program, students begin a graduate program in their fourth year of college, earning both degrees upon graduation.",
      },
      {
        question: "What is the length of study for MBA programs in the U.S.?",
        answer: "MBA programs typically last one to two years.",
      },
      {
        question: "Can you work while studying in the United States?",
        answer:
          "With permission of the International Student Office, international students may work on campus up to 20 hours/week in their first year and can apply to work off-campus in subsequent years.",
      },
      {
        question:
          "What is the difference between online studies and distance studies?",
        answer: "Essentially there is no difference.",
      },
      {
        question: "What is distance education?",
        answer:
          "Distance education occurs when a student and an instructor are in different places. Learning occurs by mail, telephone, internet, or by other means.",
      },
      {
        question:
          "Can I transfer to a U.S. university from a university outside of the United States?",
        answer:
          "Yes, although you may lose some credits and require extra time to complete your degree.",
      },
      {
        question: "What is the transfer application process?",
        answer:
          "You must fulfill the requirements of a freshman applicant, as well as any supplemental information required by the transfer institution.",
      },
    ],
  },
  {
    countryName: "UNITED KINGDOM",
    countryShort: "UK",
    overview:
      "Types of Scholarships available for international students in the United Kingdom",
    faqs: [
      {
        question: "What are the popular courses in the United Kingdom?",
        answer:
          "Some of the popular courses for international students include business management and engineering, including computing. Some international students are also taking courses in waste management and environmental sciences.",
      },
      {
        question: "How much is the study cost in the United Kingdom?",
        answer:
          "The cost of an undergraduate program in the United Kingdom for international students ranges between £10,000 to £38,000 and more for a medical degree. While for a post graduate degree program the cost ranges between £11,000 and £32,000 for a classroom based program. For laboratory based programs it ranges from £12,000 to £27,200.",
      },
      {
        question: "What are the work-during-study opportunities?",
        answer:
          "Students in the United Kingdom have the opportunity of working for 20 hours per week.",
      },
      {
        question:
          "What are the intakes offered by the United Kingdom universities?",
        answer:
          "The main intake offered by universities is September and October whereas a few universities also offer January and February intake. Some may have April and May intake too.",
      },
      {
        question: "Are there any scholarships offered?",
        answer:
          "There are various sources of scholarships to international students offered by the university itself. Other sources through which scholarships are given are the British Government or by local organizations from the student’s home country. Scholarships are competitive in nature and students need to have a strong profile.",
      },
      {
        question: "Do I need to appear for any entrance exams?",
        answer: `<p>Below given is the brief framework of entrance exams for certain programs:</p>

        <ul>
         <li>IELTS/TOEFL if the student is looking to pursue an undergraduate or postgraduate course</li>
         <li>GMAT/GRE if pursuing an MBA and MSC program in Finance in selected universities</li>
         <li>LNAT for law programs</li>
         <li>UCAT for medicine or dentistry programs</li>
        </ul>
        `,
      },
      {
        question: "How can I pay for my studies in the United Kingdom?",
        answer:
          "Study in United Kingdom for Indian students can be sourced through family funds, bank loans, scholarships, bursaries, sponsorships, etc. Students can also utilize bank loans, savings accounts, and fixed deposits maintained for a period of 28 days. Most nationalized banks offer student loans at competitive rates for considerable time periods, which may enable a larger section of students. However, they will ask for collateral security to be pledged. You can even consider the possibility of an international bank loan.",
      },
      {
        question: "Do I get to work during my course in the United Kingdom?",
        answer:
          "You can work up to 20 hours a week during the course duration and full-time during course breaks. You can expect to approximately earn £375-£525 per month during the term. This will not only help you recover your cost but also undertake new experiences.",
      },
      {
        question:
          "What are the job opportunities in the United Kingdom, after I complete my program?",
        answer:
          "Students can stay back in the United Kingdom two years upon the completion of the course. Until recently, students received a stay back of mere four to six months respectively. A major benefit of the visa is that it gives international students an opportunity to look for jobs. Once the graduate finds an appropriate job, they can switch to the skilled work segment which is a route towards settlement.",
      },
    ],
  },
  {
    countryName: "CANADA",
    countryShort: "Canada",
    overview:
      "There are three types of scholarships available for study abroad Canada",
    faqs: [
      {
        question: "What is the procedure to study in Canada?",
        answer:
          "The first step is to get admission to a Canadian Designated Learning Institution (DLI) recognized by the government of Canada. Once an individual receives a letter of acceptance from a DLI, he or she may be able to apply for a study permit. Applications may be made online or by mail. All new study permits are issued at a Canadian port of entry. An applicant who has submitted an application to a foreign Canadian Visa Office will be issued a letter of approval advising him or her to travel to a Canadian port of entry to have the study permit issued. A study permit is generally issued for the duration of the person’s studies.",
      },
      {
        question: "How much does it cost to study in Canada?",
        answer:
          "According to Statistics, the average tuition fees for an undergraduate program for international students in Canada is CA$29714 per year. Humanities courses tend to be cheaper, with an average of $5,542, while subjects such as engineering and medicine are among the most expensive with an average of CA$21,717 for dentistry and $14,162 for Medicine. Fees for business and management courses go around CA$6,827 per year.",
      },
      {
        question:
          "Do I need to show proof of funds when applying for study permit?",
        answer:
          "Yes, students need to prove that they can support themselves financially while living in Canada.",
      },
      {
        question:
          "Are scholarships available to international students in Canada?",
        answer:
          "Scholarships are available to international students from private, government or public institutions in Canada. There are also scholarships that are available to international students from the study institution of choice.",
      },
      {
        question: "Is it possible to work during studies in Canada?",
        answer:
          "Study permit holders may be allowed to work for up to 20 hours per week during regular academic sessions and full time during scheduled breaks",
      },
      {
        question:
          "What type of a high school diploma is accepted if applying in a Canadian post-secondary educational institution?",
        answer:
          "Any student possessing a government-accredited high school diploma from their home country may apply for admission to a Canadian University.",
      },
      {
        question:
          "What is the main difference between Universities and Colleges in Canada?",
        answer:
          "Universities get to deal independently with academic matters regarding the curriculum, methods and teaching strategies. Universities have the power to set academic, admission, and graduation policies and standards, appoint staff, and undertake academic planning, meanwhile Private Universities are out-of-province institutions permitted to provide degrees after a meticulous quality assessment process by the designated governmental authorities which give the green light to certain degrees.",
      },
      {
        question:
          "What are the common requirements into getting accepted in a Canadian University/College?",
        answer:
          "Depending on the field of studies, programs and other relevant factors requirements can vary. The two essential criteria are however, high school grades/performance as well as language skills be it English (in most of the provinces) or French in francophone ones",
      },
      {
        question: "How long does it take to get a Master degree in Canada?",
        answer:
          "Commonly, Master degrees last for a whole academic year including an obligatory internship added to the overall duration. Sometimes a Master degree can last for two academic years, depending on the curriculum of the program.",
      },
      {
        question:
          "What type of documentation will I need in order to apply for a student visa in Canada?",
        answer: `<p>You will generally need the following documents for your Canada Student Visa application:</p>
        <p>Valid Passport<br />Attested copies of 10th, 12th and Degree certificates<br />Academic references - 2<br />Employer references - 2<br />SOP (Statement of Purpose)<br />Certificates of extracurricular achievements<br />An acceptance letter from your education institution<br />Proof of payment<br />Proof of financial funds<br />Two Passport size photographs<br />Study Permit and visa<br />Proof of English Proficiency</p>`,
      },
      {
        question: "Do I need Health insurance if I want to study in Canada?",
        answer:
          "For studying abroad in Canada, international students must all have health insurance one way or the other.",
      },
    ],
  },
  {
    countryName: "U.A.E",
    countryShort: "U.A.E",
    overview:
      "In Dubai, you can study on fully or partially funded scholarships. Every year, the government of Dubai and universities in Dubai award scholarships to international students and local residents, here is a compiled list of some of the best PhD Scholarships in Dubai, Masters Scholarships in Dubai, and undergraduate level scholarships.",
    faqs: [
      {
        question: "Why choose Dubai as a study abroad destination?",
        answer:
          "Due to its cosmopolitan culture, friendly residents, and relatively low tuition, Dubai has become popular among Indian students in recent years. Dubai is a well-known global business hub with numerous opportunities for students to gain hands-on experience. Dubai has a world-class education system, with some of the world's best universities and colleges. There are also numerous professional courses and training programs available to assist you in preparing for all-round development in any field of interest. Because of its proximity to India, Dubai is also popular among Indian students.",
      },
      {
        question:
          "Which exams/tests must be taken in order to apply and study in Dubai?",
        answer:
          "International students who wish to pursue studies in Dubai are usually exempt from taking English proficiency tests such as the IELTS, PTE, or TOEFL. One of the benefits of studying in Dubai is that students are not required to prove their English proficiency, unlike universities in the United Kingdom, the United States, Australia, or any other country, making the application process more accessible. Certificates from any English medium school, as well as academic merit and other similar eligibility criteria, can be used to apply to universities and colleges.",
      },
      {
        question: "What are the few of the popular courses to study in Dubai?",
        answer: `<p>Popular courses to study in Dubai:<br />International Hospitality Management<br />Aerospace Engineering<br />Civil Engineering/Construction Management<br />Business Administration/MBA<br />Accounts and Finance<br />Medicine<br />Aviation<br />Design Studies<br />Architecture</p>`,
      },
      {
        question:
          "Is it possible to work part-time in Dubai while on a student visa?",
        answer:
          "International students studying in Dubai are allowed to work part-time in free zone areas for 20 hours per week. They must obtain permission from universities in order to do so.",
      },
      {
        question: "What is the cost of studying in Dubai?",
        answer: `<p>Cost of Study: <br />Programmes Dubai Currency Indian Currency<br />Under Graduates 40,000 AED to 50,000 AED p.a 6 lakhs to 7 lakhs p.a<br />Post Graduate 52,800 AED to 84,000 AED 8 lakhs to 13 lakhs</p>`,
      },
      {
        question: "What are the various job opportunities available in Dubai?",
        answer:
          "Dubai has evolved into a land of possibilities over the last two decades. The country is undergoing such massive growth, expansion, and development that it requires people from various backgrounds and countries, as well as large numbers of people with the appropriate experience and education.",
      },
      {
        question: "How to apply for Permanent Residency in Dubai?",
        answer:
          "In Dubai, you will not be able to apply for a permanent residency visa. Citizens of other countries can apply for temporary residency in the UAE, which is renewable.",
      },
      {
        question:
          "Are scholarships available to international students in Dubai?",
        answer:
          "Most foreign universities offer scholarships, fellowships, and grants to international students who meet certain criteria.",
      },
    ],
  },
  {
    countryName: "GERMANY",
    countryShort: "Germany",
    overview:
      "There is a vast variety of scholarships available for international students.",
    faqs: [
      {
        question: "",
        answer: "",
      },
    ],
  },
  {
    countryName: "AUSTRALIA",
    countryShort: "Australia",
    overview:
      "There is a vast variety of scholarships available for international students.",
    faqs: [
      {
        question:
          "How Much Does It Cost To Study Abroad In Australia As An International Student?",
        answer:
          "The study abroad Australia expense of degrees differs depending on the institution and course chosen. Undergraduate degrees will range from AU$15,000 to AU$35,000. Courses in medicine and veterinary science would be more expensive. Study abroad Australia cost for postgraduate programs will range between AU$20,000 to AU$40,000.",
      },
      {
        question: "What are the requirements to study in Australia?",
        answer:
          "The requirements differ depending on the curriculum chosen. Applicants to undergraduate programs are required to have a minimum IELTS score of 6.0. Postgraduate programs usually expect students to have an IELTS score between 6.5 and 7.0. Many interested in pursuing a postgraduate degree should have a strong academic background.",
      },
      {
        question:
          "What are the cheapest universities in Australia for international students?",
        answer: `<p>University of Southern Queensland<br />Southern Cross University<br />Charles Darwin University<br />University of New England</p>`,
      },
      {
        question:
          "What are my work opportunities after the completion of my program?",
        answer:
          "Bachelor's and Master's by coursework graduates who have spent at least two academic years are eligible to attain two years of Post Study Work Right. Furthermore, Masters by research graduates receive three years of Post Study Work Rights. Lastly, Doctorate graduates receive four years of Post Study Work Rights.",
      },
      {
        question: "What are my work entitlements as a student in Australia?",
        answer:
          "In Australia, students are eligible to work around 40 hours every fortnight during their course term and unlimited hours during vacation time. Students have to remember to keep their degree in focus while working as that is one of the rules that universities insist on. The only restriction is that students cannot start working until their course begins. Students are also required to have a Tax File Number (TFN) to work in Australia.",
      },
      {
        question: "How much can I earn working as a student?",
        answer:
          "Students can earn around $18 to $22 an hour during employment.",
      },
      {
        question:
          "How long does the visa application process for an Australian student visa take?",
        answer:
          "The Australian High Commission on an average takes 4-12 weeks to process the visa. However, this is dependent on the applicant's background. Therefore, it is highly recommended that you should make your application for the visa 3 months prior to the commencement of the program.",
      },
      {
        question: "What are the popular courses in Australia?",
        answer:
          "Australian universities offer a range of courses to their students. Few of the most popular ones included Agriculture, Administration & Law, Education, Engineering, Health Science, Hospitality & Tourism, Humanities, Mathematics & Computing, Science, Visual & Performing Arts, Communications, Information Technology, Social Studies and many more.",
      },
      {
        question: "What intakes do Australian universities offer?",
        answer:
          "There are two main intake periods offered which are February and July.",
      },
      {
        question: "When should I start making my application?",
        answer:
          "Since your university application will take 4-6 weeks to process, you should start your procedure 7-8 months before the intake.",
      },
      {
        question: "What are the benefits of studying in Australia?",
        answer:
          "A safe country with a stable democracy and pleasant climate, it also offers economical costs for tuition and living expenditure. The Visa Process is straightforward and fair, which makes it easier for students to study in Australia.",
      },
      {
        question:
          "Do I still need to appear for an English proficiency test, even if I've attained my education in English?",
        answer:
          "It is a visa requirement for students to showcase adequate English proficiency skills and thus, it is required of them to appear for the IELTS and TOEFL exams.",
      },
    ],
  },
];

export default function Faq(props) {
  const [expansionOpen, setExpansionOpen] = useState(false);
  const [selectedQuestion, setSelectedQuestion] = useState(1);
  const [selectedCountryInfo, setSelectedCountryInfo] = useState({
    countryName: "AUSTRALIA",
    countryShort: "Australia",
    overview:
      "There is a vast variety of scholarships available for international students.",
    faqs: [
      {
        question: "",
        answer: "",
      },
    ],
  });

  const handleExpansion = (index) => {
    if (index === selectedQuestion) {
      setExpansionOpen(!expansionOpen);
    } else {
      setExpansionOpen(true);
    }
    setSelectedQuestion(index);
  };

  useEffect(() => {
    if (props.selectedTab) {
      const countryInfo = countriesFaqs.findIndex((info) => {
        return info.countryName === props.selectedTab;
      });

      setSelectedCountryInfo(countriesFaqs[countryInfo]);
    }
  }, [props.selectedTab]);

  const renderFaqs = selectedCountryInfo.faqs.map((item, index) => {
    return (
      <div className="accordion-item" key={Math.random()}>
        <h2 className="accordion-header" id={"heading_" + index}>
          <button
            className="accordion-button"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target={"#collapse_" + index}
            aria-expanded="true"
            aria-controls={"collapse_" + index}
          >
            {item?.question}
          </button>
        </h2>
        <div
          id={"collapse_" + index}
          className="accordion-collapse collapse "
          aria-labelledby={"heading_" + index}
          data-bs-parent="#accordionExample"
        >
          <div
            className="accordion-body"
            dangerouslySetInnerHTML={{
              __html: item?.answer,
            }}
          ></div>
        </div>
      </div>
    );
  });

  return (
    <div className="faq-wrapper">
      <div className="container-lg">
        <div className="row faq1_res_container align-items-center justify-content-around">
          <div className="col-lg-5">
            <div
              className="title wow bounceIn"
              data-wow-delay="0.5s"
              data-wow-duration="2s"
            >
              <p
                className="sub-title_faq wow bounceIn"
                data-wow-delay="1s"
                data-wow-duration="2s"
              >
                Have a Question ?
              </p>
              <span className="freq_title">FREQUENTLY ASKED QUESTION </span>
            </div>
          </div>
          <div className="col-lg-3">
            <div
              className="faq-title-image wow bounceIn"
              data-wow-delay="1.5s"
              data-wow-duration="2s"
            >
              <img src={faq_img} alt="Faq-title" />
            </div>
          </div>
        </div>
      </div>
      <div className=" faq-accordian-block">
        <div className="container-lg">
          <div
            className="accordion wow bounceIn accordian_container"
            id="accordionExample"
            data-wow-delay="2s"
            data-wow-duration="2s"
          >
            {renderFaqs}
          </div>
        </div>
      </div>
    </div>
  );
}
